// Configuration for the frontend application
// These values will be replaced during deployment or set via environment variables

export const config = {
  // API Gateway URL
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3001',

  // Cognito configuration
  cognito: {
    userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
    userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
    domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
    region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
  },

  // OAuth callback URLs
  oauth: {
    redirectSignIn: import.meta.env.VITE_REDIRECT_SIGN_IN || 'http://localhost:3000/callback',
    redirectSignOut: import.meta.env.VITE_REDIRECT_SIGN_OUT || 'http://localhost:3000/',
  },
}
